import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function GuardianshipPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas.guardianship} />;
}
